import React from 'react';
import CleaningSchedule from '../../components/facilities/CleaningSchedule';

const CleaningSchedulePage = () => {
  return (
    <div className="cleaning-schedule-page">
      <CleaningSchedule />
    </div>
  );
};

export default CleaningSchedulePage;